const AUTHORIZE_STATUS = {
  AUTHORIZE: 1,
  AUTHORIZED: 2,
  EXPIRED: 3
};

export default AUTHORIZE_STATUS;
